/***********************************************************
 Format Helpers
 --------------------------
 Contains helper functions to format variables.
 ************************************************************/

import {extractUrls} from "./parse_helpers";
import {isObject} from "./object_helpers";

/**
 * @param value
 * @param unit
 * @param defaultValue
 */
export function formatDimension(value, unit = 'px', defaultValue = null) {
    if ([null, undefined].includes(value)) {
        return defaultValue;
    }

    return isNaN(value) ? value : (value + unit);
}

/**
 * Returns an array with the dimension value on index 0 and the dimension unit on index 1.
 *
 * @param value
 * @returns {*[]|(number|string)[]}
 */
export function splitDimensionParts(value) {
    if (!value) {
        return [null, null];
    }

    const [,dimensionValue, dimensionUnit] = value.toString().match(/([\d|.]*)(\D*)/);

    return [parseFloat(dimensionValue), dimensionUnit.length ? dimensionUnit : null]
}

/**
 * Escapes the specified string to be used as a regexp.
 *
 * @param string
 * @returns {*}
 */
export function escapeRegExp(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
}

/**
 * Transforms all urls of the specified text to HTML links that are not converted yet.
 *
 * @param {string} text
 * @returns {string}
 */
export function transformUrlsToLinks(text) {
    if (!text) {
        return text;
    }
    const matches = extractUrls(text, false);
    if (matches) {
        for (let match of matches) {
            text = text.replace(new RegExp(escapeRegExp(match), 'g'), '<a href="' + match + '" target="_blank" rel="nofollow">' + match + '</a>')
        }
    }

    return text;
}

/**
 * Builds a unified geo location object for the specified lat-lng var.
 *
 * @returns {float}
 * @param latLng
 * @param decimals 1 = 11.1km; 2 = 1.1km; 3 = 110m; 4 = 11m; 5 = 1.1m; 6 = 11cm; 7 = 11mm; 8 = 1.1mm
 */
export function formatLatLng(latLng, decimals = null) {
    if (!latLng) {
        return null;
    }

    let lat = null;
    let lng = null;
    if (Array.isArray(latLng)) {
        if (latLng.length < 2) {
            return null;
        }

        lat = latLng[0];
        lng = latLng[1];
    } else if (isObject(latLng)) {
        lat = latLng.lat;
        lng = latLng.lng ? latLng.lng : latLng.lon;
    }

    lat = parseFloat(lat);
    lng = parseFloat(lng);

    if (decimals) {
        lat = parseFloat(lat.toFixed(decimals))
        lng = parseFloat(lng.toFixed(decimals))
    }

    return {
        lat: lat,
        lng: lng,
    }
}